import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { checkAdmin, getPassCode, checkApiError } from '../../utils';
import { Button, Table, Modal } from 'react-bootstrap';
import { formatDate } from './../../common';
import './../../css/manageuserevent.css';

const EventManagement = ({ showLoading }) => {
    const [eventsList, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const isAdmin = checkAdmin();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if(getPassCode() === ""){
            navigate("/login");
        }
        const fetchEvents = async () => {
            try {
                showLoading(true);
                const response = await fetch(`${process.env.REACT_APP_API_URL}/Event/geteventlist`, {
                    method: 'GET',
                    /* headers: {
                        "Authorization": `Bearer ${getPassCode()}`,
                    } */
                });

                if(checkApiError(response.status)){ navigate("/login"); return; }

                if (response.ok) {
                    const data = await response.json();
                    setEvents(data.eventDetailsList);
                } else {
                    console.error('Error Events list not received:', response.status);
                }
                document.querySelector('#btnDelete').disabled = true;
            } catch (error) {
                console.log(error);
            } finally {
                showLoading(false);
            }
        };

        if (isAdmin) {
            fetchEvents();
        }

    }, [isAdmin, showLoading, navigate]);

    const handleAddEditEvent = (event, mode) => {
        event = event || {};
        mode === 'add' ? navigate('/event-management/event', { state: { event, mode } }) : navigate('/event-management/event', { state: { event, mode } });
    };

    const handleEventMapping = (event) => {
        navigate('/event-management/attendee-mapping', { state: { event } });
    }

    const handleDeleteEvent = async () => { setShowDeleteModal(true); };

    const handleConfirmDelete = async () => {
        const eventId = selectedEvent.eventId;
        
        try {
            showLoading(true);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/Event/deleteEventbyId?EventId=${selectedEvent.eventId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${getPassCode()}`,
                    'Accept': "*/*",
                    'Content-Type': 'application/json'
                }
            });

            if(checkApiError(response.status)){ navigate("/login"); return; }

            if (!response.ok) {
                const errorData = await response.json();
                console.error(`Error deleting event ${eventId}:`, errorData);
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            setEvents(eventsList.filter((event) => event.eventId !== eventId));
            setSelectedEvent(null);
            document.querySelector('#btnDelete').disabled = true;
        } catch (error) {
            console.error('Error deleting event:', error);
        } finally {
            setShowDeleteModal(false);
            showLoading(false);
        }
    };

    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const handleEventSelection = (event) => {
        document.querySelector('#btnDelete').disabled = false;
        //setSelectedEvent(eventsList.find(event => event.eventId === eventId));
        setSelectedEvent(event);
    }

    if (!isAdmin) {
        return <div>You do not have permission to access this page.</div>;
    }

    return (
        <div className="manage-user-events w3-container mt-4 mb-4">
            <p className="roboto-bold mb-2 color-black t-h">Manage Events</p>

            <nav aria-label="breadcrumb">
                <ol className="breadcrumb fs-0-8">
                    <li className="breadcrumb-item">
                        <Link className='color-purple' to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Manage Events
                    </li>
                </ol>
            </nav>

            <div className="row mt-4 mb-4">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className='d-flex justify-content-between align-items-center p-4 pt-3 pb-3'>
                                <p className='fw-500 m-0 s-h'>Event List</p>
                                <div className='action-btn-container'>
                                    <div className="d-flex justify-content-end align-items-center color-gray">
                                        <Button variant="purple" onClick={() => handleAddEditEvent(null, 'add')} className="me-3">Add Event</Button>

                                        <Button id="btnDelete" variant="danger" onClick={() => { handleDeleteEvent() }}>Delete</Button>
                                    </div>
                                </div>
                            </div>

                            <Table responsive>
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" className='mw-60' style={{ width: "60px" }}></th>
                                        <th scope="col" className='mw-120'>Name</th>
                                        <th scope="col" className='mw-100'>Type</th>
                                        <th scope="col" className='mw-140'>Event Date</th>
                                        <th scope="col" className='mw-140'>Venue</th>
                                        <th scope="col" className='mw-120'>Created By</th>
                                        <th scope="col" className='mw-100'>Status</th>
                                        <th scope="col" className='mw-70 text-center' style={{ width: "80px" }}>Attendees</th>
                                        <th scope="col" className='mw-70 text-center' style={{ width: "80px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eventsList.length === 0 ?
                                        (
                                            <tr>
                                                <td colSpan="9" className="text-center">No events found.</td>
                                            </tr>
                                        ) :
                                        eventsList.map((event, index) => (
                                            <tr key={event.eventId}>
                                                <td className='text-center'><input type="radio" name="event" className="btn-radio icons icon-radio" onChange={() => handleEventSelection(event)} /></td>
                                                <td>{event.eventTitle}</td>
                                                <td>{event.eventType}</td>
                                                <td>{formatDate(event.eventStartDate)}</td>
                                                <td>{event.venueName}</td>
                                                <td>{event.createdById}</td>
                                                <td><span className={`event-status ${event.eventStatus.toLowerCase()}`}>{event.eventStatus}</span></td>
                                                <td className='text-center'>
                                                    <Button variant="" size="sm" onClick={() => handleEventMapping(event)} className={`icons icon-users-solid p-0 ${event.eventStatus.toLowerCase() === 'completed' ? 'pe-none' : ''}`} disabled={event.eventStatus.toLowerCase() === 'completed'}>
                                                        <svg width="20" height="17" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M5.4 0.200195C6.19565 0.200195 6.95871 0.529435 7.52132 1.11549C8.08393 1.70154 8.4 2.49639 8.4 3.3252C8.4 4.154 8.08393 4.94885 7.52132 5.5349C6.95871 6.12096 6.19565 6.4502 5.4 6.4502C4.60435 6.4502 3.84129 6.12096 3.27868 5.5349C2.71607 4.94885 2.4 4.154 2.4 3.3252C2.4 2.49639 2.71607 1.70154 3.27868 1.11549C3.84129 0.529435 4.60435 0.200195 5.4 0.200195ZM19.2 0.200195C19.9957 0.200195 20.7587 0.529435 21.3213 1.11549C21.8839 1.70154 22.2 2.49639 22.2 3.3252C22.2 4.154 21.8839 4.94885 21.3213 5.5349C20.7587 6.12096 19.9957 6.4502 19.2 6.4502C18.4044 6.4502 17.6413 6.12096 17.0787 5.5349C16.5161 4.94885 16.2 4.154 16.2 3.3252C16.2 2.49639 16.5161 1.70154 17.0787 1.11549C17.6413 0.529435 18.4044 0.200195 19.2 0.200195ZM0 11.8682C0 9.56738 1.7925 7.7002 4.00125 7.7002H5.6025C6.19875 7.7002 6.765 7.83691 7.275 8.0791C7.22625 8.36035 7.20375 8.65332 7.20375 8.9502C7.20375 10.4424 7.83375 11.7822 8.8275 12.7002C8.82 12.7002 8.8125 12.7002 8.80125 12.7002H0.79875C0.36 12.7002 0 12.3252 0 11.8682ZM15.1988 12.7002C15.1913 12.7002 15.1838 12.7002 15.1725 12.7002C16.17 11.7822 16.7963 10.4424 16.7963 8.9502C16.7963 8.65332 16.77 8.36426 16.725 8.0791C17.235 7.83301 17.8013 7.7002 18.3975 7.7002H19.9988C22.2075 7.7002 24 9.56738 24 11.8682C24 12.3291 23.64 12.7002 23.2013 12.7002H15.1988ZM8.4 8.9502C8.4 7.95563 8.77929 7.00181 9.45442 6.29855C10.1295 5.59528 11.0452 5.2002 12 5.2002C12.9548 5.2002 13.8705 5.59528 14.5456 6.29855C15.2207 7.00181 15.6 7.95563 15.6 8.9502C15.6 9.94476 15.2207 10.8986 14.5456 11.6018C13.8705 12.3051 12.9548 12.7002 12 12.7002C11.0452 12.7002 10.1295 12.3051 9.45442 11.6018C8.77929 10.8986 8.4 9.94476 8.4 8.9502ZM4.8 19.1572C4.8 16.2822 7.03875 13.9502 9.79875 13.9502H14.2013C16.9613 13.9502 19.2 16.2822 19.2 19.1572C19.2 19.7314 18.7538 20.2002 18.1988 20.2002H5.80125C5.25 20.2002 4.8 19.7354 4.8 19.1572Z" fill="currentColor"/>
                                                        </svg>
                                                    </Button>
                                                </td>
                                                <td className='text-center'>
                                                    <Button variant="" size="sm" onClick={() => handleAddEditEvent(event, 'edit')} className={`icons icon-edit-solid p-0 ${event.eventStatus.toLowerCase() === 'completed' ? 'pe-none' : ''}`} disabled={event.eventStatus.toLowerCase() === 'completed'}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                            <path d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                        </svg>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Do you want to remove the "<span className='fw-bold'>{selectedEvent && selectedEvent?.eventTitle}</span>" event record?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleConfirmDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default EventManagement;

